/**
 * WordPress dependencies
 */
import { createContext } from '@wordpress/element';
export const context = createContext();
//# sourceMappingURL=context.js.map